
// BlogDetail.jsx
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Badge } from 'react-bootstrap';
import { FaCalendarAlt, FaUser } from 'react-icons/fa';
import '../../../assets/css/student/blogs/BlogDetail.css';
import MyNavbar from '../../../components/student/mynavbar/MyNavbar';
const blogsData = [
  {
    id: 1,
    badge: 'Donation Awareness',
    badgeColor: '#28a745',
    image: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800',
    title: 'How Your Donations Change Student Lives',
    description: 'Discover the impact of your contributions on students education and future.',
    content: `
      Donations play a vital role in shaping the future of deserving students. 
      Every contribution you make goes directly toward educational materials, tuition fees, 
      and extra-curricular activities that enrich students' learning experience. 

      By supporting these students, you’re not only changing their lives, but also impacting the 
      community positively, helping create a generation that gives back. 
      Your generosity ensures no talented student is left behind due to financial limitations.
    `,
    date: 'April 22, 2024',
    author: 'Admin'
  },
  {
    id: 2,
    badge: 'Education Support',
    badgeColor: '#007bff',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800',
    title: 'Success Stories: Students Achieving Their Dreams',
    description: 'Read inspiring stories of students who succeeded thanks to generous donors.',
    content: `
      Many students have achieved remarkable milestones thanks to the support of our donors. 
      From winning scholarships to excelling in their studies and extracurricular activities, 
      these success stories demonstrate the real impact of your contributions. 

      Each story is a testament to the fact that your generosity empowers dreams 
      and turns potential into achievement.
    `,
    date: 'April 18, 2024',
    author: 'Admin'
  },
  {
    id: 3,
    badge: 'NGO Updates',
    badgeColor: '#ff9800',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800',
    title: 'The Role of NGOs in Supporting Education',
    description: 'Learn how NGOs verify and assist students in need of financial help to continue their studies.',
    content: `
      NGOs play a crucial role in ensuring that students from underprivileged backgrounds 
      continue their education without interruption. 

      They carefully verify the financial status of students and provide necessary support 
      such as scholarships, books, uniforms, and mentorship. This ensures equal opportunity 
      for every student to succeed academically and pursue their dreams.
    `,
    date: 'April 15, 2024',
    author: 'Admin'
  }
];

const BlogDetail = () => {
  const { id } = useParams();
  const blog = blogsData.find(b => b.id === parseInt(id));

  if (!blog) return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Blog not found.</p>;

  return (
    <Container className="blog-detail-section my-5">
      <Link to="/blogs" className="btn btn-secondary mb-4">← Back to Blogs</Link>
      
      <div className="blog-detail-card">
        <MyNavbar/>
        <div className="blog-image-wrapper">
          <img src={blog.image} alt={blog.title} className="blog-detail-image" />
          <Badge style={{ backgroundColor: blog.badgeColor }} className="blog-badge">
            {blog.badge}
          </Badge>
        </div>

        <h2 className="blog-detail-title">{blog.title}</h2>

        <div className="blog-detail-meta mb-3">
          <span><FaCalendarAlt size={14} /> {blog.date}</span> | <span><FaUser size={14} /> {blog.author}</span>
        </div>

        <p className="blog-detail-description">{blog.description}</p>
        <div className="blog-detail-content">
          {blog.content.split('\n').map((para, idx) => (
            <p key={idx}>{para.trim()}</p>
          ))}
        </div>
      </div>
    </Container>

  
  );
};

export default BlogDetail;